import React from 'react';
import { CheckIcon, StarIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface PricingCardProps {
  idAttr?: string;
}
export function PricingCard({
  idAttr = 'pricing'
}: PricingCardProps) {
  return <section id={idAttr} className="py-8 px-4 bg-white scroll-mt-10" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <div className="text-center mb-6" data-id="element-98">
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-forest mb-2 leading-tight" data-id="element-99">
            Elige tu Nivel de Transformación Hoy
          </h2>
        </div>

        <div className="flex flex-col gap-6" data-id="element-100">
          {/* OPCIÓN 1: KIT ESENCIAL */}
          <div className="bg-brand-cream border border-brand-border rounded-lg p-5" data-id="element-101">
            <h3 className="text-lg font-bold text-brand-forest mb-1" data-id="element-102">
              Opción 1: Kit Esencial
            </h3>
            <p className="text-sm text-brand-muted mb-4" data-id="element-103">
              Lo fundamental para desinflamarte.
            </p>

            <div className="space-y-2 mb-5" data-id="element-104">
              <div className="flex items-start gap-2" data-id="element-105">
                <CheckIcon className="w-5 h-5 text-brand-forest shrink-0" data-id="element-106" />
                <span className="text-sm text-brand-text" data-id="element-107">
                  Protocolo Maestro Tiroides en Rescate
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-108">
                <CheckIcon className="w-5 h-5 text-brand-forest shrink-0" data-id="element-109" />
                <span className="text-sm text-brand-text" data-id="element-110">
                  6 Bonos de Regalo (Checklist, Ahorro, etc.)
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-111">
                <XIcon className="w-5 h-5 text-red-500 shrink-0" data-id="element-112" />
                <span className="text-sm text-brand-muted line-through" data-id="element-113">
                  No incluye Plan de Acción 21 Días
                </span>
              </div>
            </div>

            <div className="flex justify-between items-end border-t border-brand-border pt-4 mb-4" data-id="element-114">
              <span className="text-xs text-brand-muted uppercase font-bold" data-id="element-115">
                Precio Hoy
              </span>
              <span className="text-2xl font-bold text-brand-forest" data-id="element-116">
                $19.90 USD
              </span>
            </div>

            <CTAButton href="https://a3dm10-h0.myshopify.com/cart/44789758591111:1" variant="secondary" data-id="element-117">
              ELEGIR ESTE KIT
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-[10px] sm:text-xs text-brand-muted mt-3" data-id="element-118">
              <span data-id="element-119">🔒 Pago 100% Seguro</span>
              <span data-id="element-120">•</span>
              <span data-id="element-121">📥 Entrega Inmediata</span>
              <span data-id="element-122">•</span>
              <span data-id="element-123">🌍 Paga en tu Moneda Local</span>
              <span data-id="element-124">•</span>
              <span data-id="element-125">🛡️ Garantía Total</span>
            </div>
          </div>

          {/* OPCIÓN 2: SISTEMA COMPLETO */}
          <div className="bg-brand-forest text-white rounded-lg p-5 border-2 border-brand-lime relative" data-id="element-126">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-lime text-white font-bold px-3 py-1 rounded-full text-xs uppercase flex items-center gap-1" data-id="element-127">
              <StarIcon className="w-3 h-3 fill-current" data-id="element-128" />
              Recomendado
            </div>

            <h3 className="text-lg font-bold text-white mb-1 mt-2" data-id="element-129">
              Opción 2: Sistema Completo ⭐
            </h3>
            <p className="text-sm text-white/80 mb-4" data-id="element-130">
              La transformación definitiva "Cero Pensamiento".
            </p>

            <div className="space-y-2 mb-5" data-id="element-131">
              <div className="flex items-start gap-2" data-id="element-132">
                <CheckIcon className="w-5 h-5 text-brand-lime shrink-0" data-id="element-133" />
                <span className="text-sm" data-id="element-134">
                  Protocolo Maestro Tiroides en Rescate
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-135">
                <CheckIcon className="w-5 h-5 text-brand-lime shrink-0" data-id="element-136" />
                <span className="text-sm" data-id="element-137">
                  6 Bonos de Regalo (Checklist, Ahorro, etc.)
                </span>
              </div>
              <div className="flex items-start gap-2 bg-white/10 p-3 rounded mt-2" data-id="element-138">
                <CheckIcon className="w-5 h-5 text-brand-lime shrink-0" data-id="element-139" />
                <div data-id="element-140">
                  <span className="text-sm font-bold text-brand-lime block" data-id="element-141">
                    🌟 PLUS: El Acelerador 21 Días (Sistema Maestro)
                  </span>
                  <span className="text-xs text-white/80" data-id="element-142">
                    El mapa día a día de qué comer para no tomar ni una sola
                    decisión.
                  </span>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-end border-t border-white/20 pt-4 mb-4" data-id="element-143">
              <span className="text-xs text-white/60 uppercase font-bold" data-id="element-144">
                Precio Hoy
              </span>
              <span className="text-3xl font-bold text-white" data-id="element-145">$26.90 USD</span>
            </div>

            <CTAButton href="https://a3dm10-h0.myshopify.com/cart/44789770354823:1" variant="primary" data-id="element-146">
              OBTENER EL SISTEMA COMPLETO
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-[10px] sm:text-xs text-white/70 mt-3" data-id="element-147">
              <span data-id="element-148">🔒 Pago 100% Seguro</span>
              <span data-id="element-149">•</span>
              <span data-id="element-150">📥 Entrega Inmediata</span>
              <span data-id="element-151">•</span>
              <span data-id="element-152">🌍 Paga en tu Moneda Local</span>
              <span data-id="element-153">•</span>
              <span data-id="element-154">🛡️ Garantía Total</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}